// ============================================================
// data/howItWorks.ts — 5 passos do fluxo Lume
// ============================================================

export interface HowItWorksStep {
  id: string;
  iconKey: 'hands' | 'wearable' | 'spark' | 'chart' | 'waves';
  title: string;
  body: string;
}

export const howItWorks: ReadonlyArray<HowItWorksStep> = [
  {
    id: 'natural',
    iconKey: 'hands',
    title: 'Uso natural do dispositivo',
    body:
      'Paciente usa o app no celular ou PC para humor, CAA e distração. Cuidador registra ABC e medicação. Sem fricção.',
  },
  {
    id: 'wearable',
    iconKey: 'wearable',
    title: 'Wearable opcional',
    body:
      'Polar H10 capta frequência cardíaca e HRV em janelas de 60 segundos. Sinal bruto NUNCA sai do dispositivo — apenas features derivadas.',
  },
  {
    id: 'ai',
    iconKey: 'spark',
    title: 'IA clínica sumariza',
    body:
      'Cloud Functions chamam o motor de IA com salvaguardas declarativas. Toda saída é flagada como hipótese e cita os eventos justificadores no prontuário.',
  },
  {
    id: 'chart',
    iconKey: 'chart',
    title: 'Painel médico',
    body:
      'Linha do tempo, indicador de fonte de dados (Android+wearable / Android-only / PC / iOS comportamental) e citações rastreáveis.',
  },
  {
    id: 'modes',
    iconKey: 'waves',
    title: 'Modos especiais',
    body:
      'Modo Calma para autorregulação, Modo Crise com SAMU 192, Modo Distração com stim toys digitais que coletam features passivas.',
  },
];
